import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import moment from 'moment-timezone';
import { Link, useParams } from 'react-router-dom';
import { renderMedia } from './services/service';


const ViewPendingAiGeneratedSchedulePost = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const ContentId = useParams("ContentId")

    const handleDate = (scheduledPostDate) => {
        // Combine date and time into a single datetime string
        const dateTimeString = `${scheduledPostDate?.split('T')[0]}`;
    
        // Parse the combined date-time string
        const dateTime = moment.utc(dateTimeString);
    
        // Format date and local time
        const date = dateTime.format('YYYY-MM-DD');
        const time = dateTime.local().format('HH:mm');
    
        return { date };
    };

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                console.log(ContentId)
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallgeneratedpostsbyContentId/${ContentId.ContentId}`);
                setPosts(response.data);
                //  console.log(response.data.filter((x) => x?.ContentId == ContentId.ContentId))
                setPosts(response.data)
                console.log(response.data)
                  setLoading(false);
            } catch (err) {
                console.error('Failed to fetch posts:', err.message);
                setError('Failed to fetch posts');
                setLoading(false);
            }
        };
fetchPosts();
    }, []);
    // const renderMedia = (imagePath) => {
    //   if (imagePath) {
    //     // Convert backslashes to forward slashes for URLs
    //     const normalizedPath = imagePath.replace(/\\/g, '/');
    //     const fileExtension = normalizedPath.split('.').pop().toLowerCase();
    //     const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/${normalizedPath}`;
    
    //     if (['mp4', 'mov', 'avi'].includes(fileExtension)) {
    //       return (
    //         <div className='mt-3 mb-3 text-center'>
    //          <video width="320" height="240" controls>
    //             <source src={fileUrl} type={`video/${fileExtension}`} />
    //             Your browser does not support the video tag.
    //           </video>
    //         </div>
    //       );
    //     } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
    //       return (
    //         <div className='mt-3 mb-3 text-center'>
    //          <img src={fileUrl} alt="Post Media" height={150} width={150} />
    //         </div>
    //       );
    //     }
    //   }
    //   return null;
    // };
    
    const handleTime = (scheduledTimeAsPerZone) => {
        if (!scheduledTimeAsPerZone) {
          return { time: 'No time available' }; // Handle empty or undefined input
        }
    
        // Split the string by 'T' and take the second part (time)
        const timeString = scheduledTimeAsPerZone?.split('T')[1];
    
        // If there's a time part, format it; otherwise, return an error message
        if (timeString) {
          const timeParts = timeString.split(':');
          const formattedTime = `${timeParts[0]}:${timeParts[1]}`; // Get hours and minutes
          return { time: formattedTime };
        } else {
          return { time: 'Invalid time' };
        }
      };


    const { date } = handleDate(posts[0]?.ScheduledPostDate);  
    const { time } = handleTime(posts[0]?.ScheduledTimeAsPerZone)

    return (
        <SideNavbar>
            <div className='container'>
            <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
                <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
                <Link to= "/viewallpendingposts">
                    <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}><i class="fa fa-arrow-left" style={{marginRight:'30px'}}aria-hidden="true"></i>Linkedin Posts</h5>
                      </Link> 
                </div>
                <hr />
                {loading ? (
                    <div className='spinner'></div>
                ) : (
         
                                <li className='mt-5' style={{ listStyle: "none" }} key={posts[0]?.ContentId}>
                                    {posts[0]?.image !=null &&     <div className='mt-3'><b style={{ color: "#2e3192" }}>Media: </b> {renderMedia(posts[0]?.image)}</div> }

                                    <p   className='mt-3' style={{ color: "#000" }}><b style={{color:"#2e3192"}} >Scheduled Date: </b>{date}</p>
                                    <p   className='mt-3' style={{ color: "#000" }}><b style={{color:"#2e3192"}} >Scheduled Time: </b> {time}</p>
                                    <p   className='mt-3' style={{ color: "#000" }}><b style={{color:"#2e3192"}} >Time Zone: </b>{posts[0]?.TimeZone}</p>

                                    <p   className='mt-3' style={{ color: "#000" }}><b style={{color:"#2e3192"}} > Prompts:</b>  {posts[0]?.Prompts}</p>
                                  
                                    <div style={{ whiteSpace: 'pre-wrap' }}>
                                    <div dangerouslySetInnerHTML={{ __html: posts[0]?.Content }}></div>
        </div>   
                                </li>)}
                  </div>
                  </div>


        </SideNavbar>
    );
};

export default ViewPendingAiGeneratedSchedulePost;
